/* eslint-disable no-restricted-globals */

export default function useDisableBackButton() {
  history.pushState(null, document.title, location.href);
  window.addEventListener('popstate', () => {
    history.pushState(null, document.title, location.href);
  });
}
